import SpecialIntructionsForm from './SpecialInstructionsForm';
import WorkroomSpecialInstructionsForm from './WorkroomSpecialInstructionsForm';

const SpecialInstructionsTab = ({
	disableInputs = false,
}: {
	disableInputs?: boolean;
}) => (
	<div className="tw-min-h-[calc(100vh-360px)] tw-pt-10 tw-pb-10">
		<div className="tw-pl-8 tw-pr-8">
			<SpecialIntructionsForm disableInputs={disableInputs} />
			<WorkroomSpecialInstructionsForm disableInputs={disableInputs} />
		</div>
	</div>
);

SpecialInstructionsTab.displayName = 'SpecialInstructionsTab';

export default SpecialInstructionsTab;
